<template>
  <div>
    <v-select
      v-if="type == 'user'"
      dense
      v-model="item"
      class="mt-0"
      :items="permissions"
      @change="handleChange"
    ></v-select>
    <input
      v-else
      type="checkbox"
      @click="handleCheckboxChange($event)"
      :checked="params.value"
    />
  </div>
</template>
<script>
import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    item: null,
    type: '',
    permissions: [
      {
        text: 'Admin',
        value: 'admin'
      },
      {
        text: 'Wholesaler',
        value: 'wholesaler'
      },
      {
        text: 'Reseller',
        value: 'reseller'
      },
      {
        text: 'Customer',
        value: 'customer'
      }
    ]
  }),
  methods: {
    handleCheckboxChange(event) {
      const checked = event.target.checked
      const colId = this.params.column.colId
      this.params.node.setDataValue(colId, checked)
    },
    handleChange() {
      this.params.changed(this.item)
    },
    getValueToDisplay(params) {
      // this.type = params.data.type
      return params.data.permissionLevel
    }
  },
  beforeMount() {
    this.type = this.params.type()
    this.item = this.getValueToDisplay(this.params)
  }
})
</script>
